import { render } from "./ResetPasswordFormPos.vue?vue&type=template&id=754bb871"
import script from "./ResetPasswordFormPos.vue?vue&type=script&lang=js"
export * from "./ResetPasswordFormPos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__